class RendimentoMensalNegociadorFactory {
  makeHeaderGraficoRendimentoMensalNegociador(content, dataBase) {
    const mes = dataBase.split('/')[1];
    const ano = dataBase.split('/')[2];

    const data = [];
    if (!content) {
      return data;
    }
    for (let i = 1; i <= 12; i += 1) {
      let mesAtual = parseInt(mes, 10) + (i);
      if (mesAtual > 12) {
        mesAtual -= 12;
      }
      if (mesAtual < 10) {
        mesAtual = `0${mesAtual}`;
      }

      let anoAtual = parseInt(ano, 10) - 1;
      if (parseInt(mes, 10) + (i) > 12) {
        anoAtual += 1;
      }

      data.push({
        data: `${mesAtual}/${anoAtual}`,
      });
    }
    return data;
  }
}

export const rendimentoMensalNegociadorFactory = new RendimentoMensalNegociadorFactory();
